import React, { useEffect, useState, memo } from 'react';
import { CheckIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const Included = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const images = [{
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/n2hJ3dseqASZrAaETfypAc/5-_Tablas_de_Quesos_and_Embutidos_%28Mockup%29.png',
    alt: 'Tablas de Quesos & Embutidos'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3n6CfiHAfT3nPzesmSC4DP/8-_Maridaje_Maestro_-_50_Combinaciones_de_Bebidas_and_Finger_Foods_%28Mockup%29.png',
    alt: 'Maridaje Maestro'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sT6o4vB1zJPqjhc41dwnzk/11-_Bocaditos_Divertidos_Finger_Foods_Saludables_para_Ninos_%28Mockup%29.png',
    alt: 'Bocaditos Divertidos para Niños'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4dCgUPEvS5G2r6biwoddPP/13-_50_Canapes_Creativos_y_Rentables_%28Mockup%29.png',
    alt: '50 Canapés Creativos y Rentables'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bHQX297GVGBAZtUEURTekr/14-_30_Postres_Miniaturas_Gourmet_%28Mockup%29.png',
    alt: '30 Postres Miniaturas Gourmet'
  }];
  const nextSlide = () => {
    setCurrentSlide(prev => prev === images.length - 1 ? 0 : prev + 1);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => prev === 0 ? images.length - 1 : prev - 1);
  };
  // Auto-advance carousel every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return <section className="w-full bg-[#F5EBE0] py-16" data-id="element-136">
      <div className="container mx-auto px-4" data-id="element-137">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#8B4513] mb-12" data-id="element-138">
          🎁 Lo que obtienes hoy
        </h2>
        <div className="flex flex-col md:flex-row max-w-5xl mx-auto" data-id="element-139">
          <div className="md:w-1/2 mb-8 md:mb-0 md:pr-8" data-id="element-140">
            <div className="relative" data-id="element-141">
              <div className="relative w-full h-auto rounded-lg shadow-xl overflow-hidden" data-id="element-142">
                <img src={images[currentSlide].url} alt={images[currentSlide].alt} className="w-full h-auto object-contain" data-id="element-143" />
                {/* Navigation arrows */}
                <button onClick={prevSlide} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/70 hover:bg-white/90 rounded-full p-2 shadow-md transition-all" aria-label="Previous image" data-id="element-144">
                  <ChevronLeftIcon className="w-6 h-6 text-[#8B4513]" data-id="element-145" />
                </button>
                <button onClick={nextSlide} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/70 hover:bg-white/90 rounded-full p-2 shadow-md transition-all" aria-label="Next image" data-id="element-146">
                  <ChevronRightIcon className="w-6 h-6 text-[#8B4513]" data-id="element-147" />
                </button>
              </div>
              {/* Dots indicator */}
              <div className="flex justify-center mt-4 space-x-2" data-id="element-148">
                {images.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-3 h-3 rounded-full ${currentSlide === index ? 'bg-[#E25822]' : 'bg-[#A67C52]/40'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-149" />)}
              </div>
            </div>
          </div>
          <div className="md:w-1/2" data-id="element-150">
            <div className="bg-white p-6 rounded-lg shadow-md mb-6" data-id="element-151">
              <h3 className="text-xl font-bold text-[#8B4513] mb-4" data-id="element-152">
                El Combo Gourmet 3x1
              </h3>
              <div className="flex items-start mb-3" data-id="element-153">
                <CheckIcon className="w-5 h-5 text-[#E25822] mr-3 flex-shrink-0 mt-1" data-id="element-154" />
                <p className="text-[#5E4B3C]" data-id="element-155">
                  <span className="font-bold" data-id="element-156">Recetario Base Infalible</span> -
                  +20 Recetas de Finger Foods Gourmet
                </p>
              </div>
              <div className="flex items-start mb-3" data-id="element-157">
                <CheckIcon className="w-5 h-5 text-[#E25822] mr-3 flex-shrink-0 mt-1" data-id="element-158" />
                <p className="text-[#5E4B3C]" data-id="element-159">
                  <span className="font-bold" data-id="element-160">Salsas & Aderezos Maestros</span>{' '}
                  - 10 Mezclas Gourmet para Finger Foods
                </p>
              </div>
              <div className="flex items-start mb-3" data-id="element-161">
                <CheckIcon className="w-5 h-5 text-[#E25822] mr-3 flex-shrink-0 mt-1" data-id="element-162" />
                <p className="text-[#5E4B3C]" data-id="element-163">
                  <span className="font-bold" data-id="element-164">Técnicas Exprés de Chef</span> -
                  15 Atajos Profesionales para Finger Foods Gourmet
                </p>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-165">
              <h3 className="text-xl font-bold text-[#8B4513] mb-4" data-id="element-166">
                +10 eBooks de Bonos Exclusivos
              </h3>
              <div className="flex items-start mb-3" data-id="element-167">
                <CheckIcon className="w-5 h-5 text-[#E25822] mr-3 flex-shrink-0 mt-1" data-id="element-168" />
                <p className="text-[#5E4B3C]" data-id="element-169">
                  <span className="font-bold" data-id="element-170">
                    Tablas de Quesos & Embutidos
                  </span>{' '}
                  - Presentaciones que enamoran
                </p>
              </div>
              <div className="flex items-start mb-3" data-id="element-171">
                <CheckIcon className="w-5 h-5 text-[#E25822] mr-3 flex-shrink-0 mt-1" data-id="element-172" />
                <p className="text-[#5E4B3C]" data-id="element-173">
                  <span className="font-bold" data-id="element-174">
                    Finger Foods Internacionales
                  </span>{' '}
                  - Sabores del mundo en tu mesa
                </p>
              </div>
              <div className="flex items-start mb-3" data-id="element-175">
                <CheckIcon className="w-5 h-5 text-[#E25822] mr-3 flex-shrink-0 mt-1" data-id="element-176" />
                <p className="text-[#5E4B3C]" data-id="element-177">
                  <span className="font-bold" data-id="element-178">Patés y Mousses</span> - Para
                  aperitivos gourmet
                </p>
              </div>
              <div className="flex items-start mb-3" data-id="element-179">
                <CheckIcon className="w-5 h-5 text-[#E25822] mr-3 flex-shrink-0 mt-1" data-id="element-180" />
                <p className="text-[#5E4B3C]" data-id="element-181">
                  <span className="font-bold" data-id="element-182">Maridaje Maestro</span> -
                  Combinaciones perfectas
                </p>
              </div>
              <div className="flex items-start mb-3" data-id="element-183">
                <CheckIcon className="w-5 h-5 text-[#E25822] mr-3 flex-shrink-0 mt-1" data-id="element-184" />
                <p className="text-[#5E4B3C]" data-id="element-185">
                  <span className="font-bold" data-id="element-186">
                    Variaciones y Combinaciones Ilimitadas
                  </span>{' '}
                  - Matrices para Finger Foods Gourmet
                </p>
              </div>
              <div className="flex items-start mb-3" data-id="element-187">
                <CheckIcon className="w-5 h-5 text-[#E25822] mr-3 flex-shrink-0 mt-1" data-id="element-188" />
                <p className="text-[#5E4B3C]" data-id="element-189">
                  <span className="font-bold" data-id="element-190">De Anfitrion a Emprendedor</span>{' '}
                  - Transforma tu talento en un negocio
                </p>
              </div>
              <div className="flex items-start mb-3" data-id="element-191">
                <CheckIcon className="w-5 h-5 text-[#E25822] mr-3 flex-shrink-0 mt-1" data-id="element-192" />
                <p className="text-[#5E4B3C]" data-id="element-193">
                  <span className="font-bold" data-id="element-194">
                    30 Postres Miniaturas Gourmet
                  </span>{' '}
                  - El arte de crear pequeñas joyas dulces
                </p>
              </div>
              <div className="flex items-start mb-3" data-id="element-195">
                <CheckIcon className="w-5 h-5 text-[#E25822] mr-3 flex-shrink-0 mt-1" data-id="element-196" />
                <p className="text-[#5E4B3C]" data-id="element-197">
                  <span className="font-bold" data-id="element-198">
                    Bocaditos Divertidos Saludables para Niños
                  </span>{' '}
                  - Una aventura deliciosa para los más pequeños
                </p>
              </div>
              <div className="flex items-start mb-3" data-id="element-199">
                <CheckIcon className="w-5 h-5 text-[#E25822] mr-3 flex-shrink-0 mt-1" data-id="element-200" />
                <p className="text-[#5E4B3C]" data-id="element-201">
                  <span className="font-bold" data-id="element-202">Panes y Bocados Caseros</span> -
                  Bases caseras irresistibles que elevarán tus eventos
                </p>
              </div>
              <div className="flex items-start mb-3" data-id="element-203">
                <CheckIcon className="w-5 h-5 text-[#E25822] mr-3 flex-shrink-0 mt-1" data-id="element-204" />
                <p className="text-[#5E4B3C]" data-id="element-205">
                  <span className="font-bold" data-id="element-206">
                    50 Canapes Creativos y Rentables
                  </span>{' '}
                  - Crea una experiencia gastronómica memorable
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Included;